import Card from "../../../Components/Card/Card";
import classes from "./LinksSection.module.scss";
import { ReactComponent as ArrowWithTail } from "../../../assets/icons/arrow_with_tail.svg";
import { useNavigate } from "react-router-dom";

const LinksSection = () => {
  const navigate = useNavigate();

  const navLinkClickHandler = (link: string) => () => {
    navigate(link);
  };

  return (
    <div className={classes["link-section-container"]}>
      <Card
        customClass={`${classes["grid-item"]} ${classes["about-us-card"]}`}
        extraProps={{ onClick: navLinkClickHandler("/about-us") }}
      >
        <div className={classes["card-title"]}>
          About Us
          <ArrowWithTail />
        </div>

        <p className={classes["card-desc"]}>
          Sustainability Economics.ai is pioneering the convergence of clean
          energy and AI, enabling profitable energy transitions while powering
          end-to-end AI infrastructure. By integrating AI-driven cloud solutions
          with sustainable energy, we create scalable, intelligent ecosystems
          that drive efficiency, innovation, and long-term impact across
          industries.
        </p>

        <img
          src={
            "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/links-section/about-us.jpeg"
          }
          height="100%"
          width="100%"
          alt="about-us"
          loading="lazy"
          className={classes["mobile-img"]}
        ></img>
      </Card>

      <Card customClass={`${classes["grid-item"]} ${classes["grid-item-img"]}`}>
        <img
          src={
            "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/links-section/about-us.jpeg"
          }
          height="100%"
          width="100%"
          alt="about-us"
          loading="lazy"
        ></img>
      </Card>

      <Card customClass={`${classes["grid-item"]} ${classes["grid-item-img"]}`}>
        <img
          src={
            "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/links-section/solutions.jpeg"
          }
          height="100%"
          width="100%"
          alt="solutions"
          loading="lazy"
        ></img>
      </Card>

      <Card
        customClass={`${classes["grid-item"]}`}
        extraProps={{ onClick: navLinkClickHandler("/solutions") }}
      >
        <div className={classes["card-title"]}>
          Solutions <ArrowWithTail />
        </div>

        <div className={classes["card-desc"]}>
          <p>
            Our solutions are focused on enabling profitable clean energy
            transitions with AI-driven optimization and intelligent energy
            management. We are also developing sector-specific AI solutions to
            build intelligent urban ecosystems powered by clean energy and
            automation, shaping a future where AI and sustainability drive
            progress together.
          </p>
        </div>

        <img
          src={
            "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/links-section/solutions.jpeg"
          }
          height="100%"
          width="100%"
          alt="solutions"
          loading="lazy"
          className={classes["mobile-img"]}
        ></img>
      </Card>
    </div>
  );
};

export default LinksSection;
